<script>
  // import { push } from "svelte-spa-router";

  // import { getAircraftList } from "../scripts/appWrite/awFetcher";

  export let appName;

  //global page variables
  // let selectedAircraft = false;

//   let aircraftListStore = getAircraftList(AppWrite);
//   let aircraftSelection;

//   function handleSelection() {
//     if (aircraftSelection) {
//       $selectedAircraft = aircraftSelection;
//       push("/aircraft/");
//     }
//   }
// </script>

<section class="hero is-primary is-fullheight">
  <div class="hero-body">
    <div class="container">
      <div class="columns">
        <div class="column is-one-third">
          <div class="section">
            <div class="container">
              <h1 class="title">{appName}</h1>
              <p class="subtitle">Sorry - this site is closed for the moment</p>
            </div>
          </div>
          <div class="section">
          </div>
        </div>
        <div class="column">
          <div class="image is-5by3">
            <img src="./images/fsec-hero.png" alt="" />
          </div>
        </div>
      </div>
      <div class="mt-5">
        <p>Sorry folks, I had to shutdown this service for the moment.</p>
        <p>
          I need to upgrade the server I was using to fetch the data. 
          The new API also requires me to refactor the code I was using and I do not find the 
          time to do this right now, Sorry.
        </p>
        <p>
          If you cannot live without this service, reach out to me via the FSEconomy forum 
          (see the <a href="/#/about">About page</a>) and let me know. If we get 50 votes of users
          I might reconsider putting up the site again.</p>
        <p>
          In the meantime, checkout Piero-la-lunes <a href="https://fse-planner.piero-la-lune.fr/">FlightPlanner</a>
          There you can find assignements of the different aircraft as well.
          </p>
      </div>
      <div class="mt-5">
        Thanks for using this service is the past!
        </div>
      <div class="pt-10" />
    </div>
  </div>
</section>
